<template>
  <div class="news-center">
    <div class="header-box">
      <layoutHeader :default-bg="'rgba(0,0,0,0.4)'" />
    </div>
    <div class="banner">
      <img src="https://ssv-website.oss-cn-shenzhen.aliyuncs.com/mainland/image/1661418276707436313.png" alt="">
    </div>
    <div class="content">
      <div class="main-container">
        <div class="tab">
          <template v-for="(item, index) in tabData">
            <div class="item" :class="index === tabIndex ? 'active' : ''" @click="changeType(index)">{{
                item.name
              }}
            </div>
          </template>
        </div>
        <div class="article" ref="article">
          <el-row :gutter="20" type="flex" class="flex-warp">
            <template v-for="(item, index) in list">
              <el-col :xs="12" :sm="8" :md="8" :lg="6">
                <div class="item center-item" @mouseenter="onMouseEnter(index)" @mouseleave="onMouseLeave" @click="toDetail(item)">
                  <div class="top" >
                    <div class="black" v-if="currentIndex === index ">
                      <div class="link" >查看</div>
                    </div>
                      <template v-if="tabIndex === 0">

                        <el-image class="icon" :src="require('@/assets/slices/icon_news2.png')"
                                  v-if="item.type === 0"></el-image>
                        <el-image class="icon" :src="require('@/assets/slices/icon_news.png')" v-else></el-image>
                      </template>
                      <el-image class="cover" :src="item.headlineImage" fit="contain"></el-image>
                  </div>
                  <div class="info">
                    <div class="date">{{ item.createTime }}</div>
                    <div class="title">
                      {{ item.headline }}
                    </div>
                    <div class="desc">{{ item.newsSummary }}</div>
                  </div>
                </div>
              </el-col>
            </template>
          </el-row>
        </div>
        <pagination :total-page="totalPage" @pageChange="onPageChange"/>

      </div>
    </div>
  </div>
</template>

<script>
import layoutHeader from '@/components/layout/header'
import pagination from '@/components/pagination'
import router from "@/router";
import Model from '@/model/news'

export default {
  components: {
    layoutHeader,
    pagination
  },
  name: 'layout',
  data() {
    return {
      activeName: 'second',
      currentIndex: -1,
      tabIndex: 0,
      tabData: [
        {
          name: '全部',
          type: ''
        },
        {
          name: '公司新闻',
          type: 1
        },
        {
          name: '行业新闻',
          type: 0
        }
      ],
      page: 1,
      totalPage: 0,
      list: []
    }
  },
  created() {
    this.getList()
  },
  mounted() {
    window.onload = () => {
      let ele = document.getElementsByClassName(".article .el-col");
      console.log('ele1', ele)
    }
    // 获取 DOM 元素
    this.$nextTick(()=>{
      let ele = document.getElementsByClassName(".article .el-col");
      console.log('ele', ele)
    })
  },
  methods: {
    changeType(index) {
      this.tabIndex = index
      this.list = []
      this.page = 1
      this.totalPage = 0
      this.getList()
    },
    async getList() {
      const res = await Model.getJournalismList(this.tabData[this.tabIndex].type, this.page)
      this.totalPage = res.data.totalPage
      this.page++
      res.data.webJournalismRespList.forEach(item => {
        item.createTime = this.timestampToDate(item.createTime)
      })
      this.list = res.data.webJournalismRespList
    },
    handleClick(tab, event) {
      console.log(tab, event);
    },
    onMouseEnter(index) {
      this.currentIndex = index
    },
    onMouseLeave() {
      this.currentIndex = -1
    },
    toDetail(item) {
      router.push({
        name: 'NewsDetail',
        query: {id:item.id}
      })
    },
    timestampToDate(timestamp) {
      const date = new Date(timestamp);
      return  date.getFullYear() + '-' + (date.getMonth()+1 < 10 ? '0'+(date.getMonth()+1) : date.getMonth()+1) + '-' + date.getDate() + ' '
    },
    onPageChange(page) {
      this.page = page
      this.getList()
    }
  }
}
</script>

<style lang="scss" scoped>
.news-center {
  display: flex;
  flex-direction: column;
  align-items: center;

  .header-box {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    z-index: 99;
  }

  .content {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 0 40px;
    width: 100%;
    justify-content: center;
    box-sizing: border-box;
  }

  .banner {
    width: 100%;
    img{
      width: 100%;
    }
  }

  .tab {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    font-size: 24px;
    border-bottom: 1px solid #C4C4C4;
    padding-top: 7px;
    margin-bottom: 28px;

    .item {
      margin-right: 100px;
      line-height: 60px;
      cursor: pointer;
    }

    .active {
      font-weight: 500;
      color: #EB6100;
      border-bottom: 7px solid #EB6100;
    }
  }

  .article {
    .el-col{
      padding-bottom: 80px;
    }

    .item {
      width: 100%;
      height: 100%;
      display: flex;
      flex-direction: column;
      //justify-content: space-between;


      .black{
        background: #000;
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        z-index: 4;
        border-radius: 6px;
      }
      .top {
        position: relative;
        border-radius: 6px;
        font-size: 0;

        .icon {
          position: absolute;
          top: 0;
          left: 0;
          z-index: 3;
          width: 58px;
          height: 56px;
        }

        .cover {
          width: 100%;
          height: auto;
          //padding-bottom: 50%;
          border-radius: 6px;
          box-sizing: border-box;
        }

        .link {
          padding: 5px 30px;
          border-radius: 5px;
          border: 1px solid #fff;
          color: #EB6100;
          font-size: 16px;
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          z-index: 10;
          cursor: pointer;
        }
      }

      .info {
        .date {
          font-size: 16px;
          color: rgba(0, 0, 0, 0.3);
          margin: 8px 0;
        }

        .title {
          font-size: 24px;
          font-weight: 500;
          color: rgba(0, 0, 0, 0.8);
          //width: 100px;
          overflow: hidden; //超出的文本隐藏
          text-overflow: ellipsis; //溢出用省略号显示
          white-space: nowrap; //溢出不换行
          margin-bottom: 10px;
        }

        .desc {
          font-size: 16px;
          color: rgba(0, 0, 0, 0.5);
          text-overflow: -o-ellipsis-lastline;
          overflow: hidden;				//溢出内容隐藏
          text-overflow: ellipsis;		//文本溢出部分用省略号表示
          display: -webkit-box;			//特别显示模式
          -webkit-line-clamp: 2;			//行数
          line-clamp: 2;
          -webkit-box-orient: vertical;	//盒子中内容竖直排列
        }
      }
    }
  }

  .flex-warp{
    flex-wrap: wrap;
    align-items: stretch;
  }
}
</style>
